export default "__VITE_ASSET__CBfZdpJ3__"